import { AuthMethodType } from '@lit-protocol/constants';
import { getLitContractClient } from './litContract';
export const getAuthId = async (currentAuthMethod, pkp, sessionSig) => {
  var _a;
  if (currentAuthMethod.authMethodType == AuthMethodType.LitAction) return currentAuthMethod.accessToken;
  if (currentAuthMethod.authMethodType == AuthMethodType.AppleJwt) {
    const contractClient = await getLitContractClient(pkp.publicKey, sessionSig);
    const permittedAuthMethods = await contractClient.pkpPermissionsContract.read.getPermittedAuthMethods(pkp.tokenId);
    for (let index = 0; index < permittedAuthMethods.length; index++) {
      if (parseInt((_a = permittedAuthMethods[index].authMethodType) === null || _a === void 0 ? void 0 : _a.toString()) == AuthMethodType.AppleJwt) {
        return permittedAuthMethods[index].id;
      }
    }
  }
  return await LitAuthClient.getAuthIdByAuthMethod(currentAuthMethod);
};